/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import { kebabCase } from 'lodash';
import { bool, number, string } from 'prop-types';
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import BarSegment from 'components/layouts/Bar/Balance/BarSegment/BarSegment';
import { Percent, Dollar } from 'components/shared/Text/Text';
import { plusMinusValueWithSpace } from 'services/Formats';
import ValueIndicator from 'components/shared/ValueIndicator/ValueIndicator';

const BalanceSegmentContent = ({ isLoading, dollarChange, rateChange }) => {
  return (
    <Fragment>
      <span className="balance-segment-rate">
        (
        <Percent
          className={
            isLoading ? 'content-loading segment-percent' : 'segment-percent'
          }
        >
          {rateChange}
        </Percent>
        )
      </span>
      <ValueIndicator value={dollarChange} />
    </Fragment>
  );
};

const BalanceSegment = ({
  dollarChange,
  isLoading,
  label,
  rateChange,
  tooltipContent,
  extraContent,
  onlyBalance,
  is529Only,
  isAlaska529Only
}) => {
  if (onlyBalance) {
    return (
      <BarSegment
        label={label}
        tooltipContent={tooltipContent}
        segmentClass={kebabCase(label)}
      >
        <Dollar
          className={
            isLoading ? 'content-loading segment-dollar' : 'segment-dollar'
          }
        >
          {dollarChange}
        </Dollar>
        {!is529Only && extraContent}
      </BarSegment>
    );
  }

  return (
    <BarSegment
      label={label}
      segmentClass={kebabCase(label)}
      isAlaska529Only={isAlaska529Only}
    >
      <Dollar
        className={
          isLoading ? 'content-loading segment-dollar' : 'segment-dollar'
        }
        formatters={[plusMinusValueWithSpace]}
      >
        {dollarChange}
      </Dollar>
      <div className="responsive-bar-segment">
        <BalanceSegmentContent
          isLoading={isLoading}
          dollarChange={dollarChange}
          rateChange={rateChange}
        />
      </div>

      {!is529Only && extraContent}
    </BarSegment>
  );
};

BalanceSegment.propTypes = {
  isLoading: bool,
  dollarChange: number,
  rateChange: number,
  label: string
};

export default withRouter(BalanceSegment);
